import React from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

interface QRCodeGeneratorProps {
  bookingNumber: string;
  userName: string;
  gymName: string;
  open: boolean;
  onClose: () => void;
}

export const QRCodeGenerator: React.FC<QRCodeGeneratorProps> = ({
  bookingNumber,
  userName,
  gymName,
  open,
  onClose
}) => {
  const qrData = `HUSLRZ_BOOKING:${bookingNumber}`;

  const handleDownload = () => {
    const canvas = document.getElementById('qr-canvas') as HTMLCanvasElement;
    if (canvas) {
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = `booking-${bookingNumber}.png`;
      link.click();
    }
  };

  React.useEffect(() => {
    if (open && typeof window !== 'undefined') {
      // Dynamically load QR code library
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
      script.onload = () => {
        const canvas = document.getElementById('qr-canvas');
        if (canvas) {
          canvas.innerHTML = '';
          new (window as any).QRCode({
            text: qrData,
            width: 256,
            height: 256,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: (window as any).QRCode.CorrectLevel.H,
            useSVG: false
          }).makeCode();
        }
      };
      document.head.appendChild(script);
    }
  }, [open, qrData]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Booking QR Code</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, textAlign: 'center' }}>
          <Box sx={{ mb: 2 }}>
            <strong>Booking:</strong> {bookingNumber}
          </Box>
          <Box sx={{ mb: 2 }}>
            <strong>User:</strong> {userName}
          </Box>
          <Box sx={{ mb: 3 }}>
            <strong>Gym:</strong> {gymName}
          </Box>
          <Box
            id="qr-canvas"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '280px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              mb: 2
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={handleDownload} variant="contained" startIcon={<DownloadIcon />}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeGenerator;
